import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FlightsPage = lazy(() => import('../pages/flights/page'));
const ProgressPage = lazy(() => import('../pages/progress/page'));
const AbnormalPage = lazy(() => import('../pages/abnormal/page'));
const WarningsPage = lazy(() => import('../pages/warnings/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/flights',
    element: <FlightsPage />
  },
  {
    path: '/progress',
    element: <ProgressPage />
  },
  {
    path: '/progress/:id',
    element: <ProgressPage />
  },
  {
    path: '/abnormal',
    element: <AbnormalPage />
  },
  {
    path: '/abnormal/:id',
    element: <AbnormalPage />
  },
  {
    path: '/warnings',
    element: <WarningsPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
